import React from 'react';
import loadable from "@loadable/component";
import {Route} from 'react-router-dom';


const RecruitmentDashboard = loadable(() => import("./RecruitmentDashboard.js"))
const RecruitmentDetailDashboard = loadable(() => import("./RecruitmentDetailDashboard.js"))


export default [
    <Route exact path="/admin/recruitment/" element={<RecruitmentDashboard/>} />,
    <Route exact path="/admin/recruitment/:recruitmentID/" element={<RecruitmentDetailDashboard/>} />,
]